export enum BillingTypeEnum {
  INVOICE = "invoice",
  CREDIT = "credit",
  CANCELLATION = "cancellation"
}
